import React from 'react'
import styled from 'styled-components'
import LogoSeLoger from '../../../assets/logo-seloger.svg'
import LogoNextories from '../../../assets/logo-nextories.png'

const StyledBanner = styled.div`
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0rem 1rem;
  height: 70px;
`
const NextoriesBannerContainer = styled.span`
  display: flex;
  align-items: center;
  color: #253163;
  font-size: 18px;
`
const NextoriesLogo = styled.img`
  width: 162px;
  margin-left: 14px;
  margin-top: 9px;
`

const Banner = () => (
  <StyledBanner>
    <a href="http://www.seloger.com">
      <img src={LogoSeLoger} alt="SeLoger.com" />
    </a>
    <NextoriesBannerContainer title="Nextories, société de déménagement">
      en partenariat avec
      <NextoriesLogo loading="lazy" src={LogoNextories} alt="Nextories, société de déménagement" />
    </NextoriesBannerContainer>
  </StyledBanner>
)

export default Banner
